<template>
  <div class="a-vg-c--ticket a-vg-c--single-ticket" :class="{'success': isActiveTicket}" @click="onSelect()">
    <div class="a-vg-b--visible-block">
      <div class="single-ticket--row">
        <span>{{$t('vdog_round')}}: <b>{{ticket.TicketList[0].RoundNo}}</b></span>
      </div>
      <!-- <div class="single-ticket--row">
        <span>{{$t('vdog_date')}}:</span>
        <div class="date-time">
          <span>{{getDate(ticket.PayInTime)}} </span>
          <span>{{getTime(ticket.PayInTime)}}</span>
        </div>
      </div> -->
      <div class="single-ticket--row">
        <span>{{$t('vdog_id')}}:</span>
        <span class="value-field status">{{ getTicketId(ticket) }}</span>
      </div>
      <div class="single-ticket--row status">
        <span>{{$t('vdog_status')}}:</span>
        <span class="value-field">{{getStatus(ticket)}}</span>
      </div>
      <div class="single-ticket--row">
					<span>{{$t('vdog_tipsNumber')}}:</span>
					<span class="value-field">{{ticket.TicketList.length}}</span>
      </div>
      <div v-show='!ticket.isOpen' class="hidden-rows">
        <vdog-active-ticket-summary
          :class="{'summary': isActiveTicket}"
          :ticket="ticket"
          :isHistory="isHistory"
          :currency="currency"/>
      </div>
    </div>

    <div class="collapsed-block--toggle"  @click="toggleTicketView(ticket)">
      <image-svg :imageName="'arrow-expand'" :class="{'a-vg-c--rotation': ticket.isOpen}"/>
    </div>

    <div class="a-vg-b--collapsed-block" :class="{'visible': ticket.isOpen}">
				<!-- Single event -->
        <vdog-active-ticket-single-event
          class="single-event"
          v-for="(item, index) in ticket.TicketList" :key="index"
          :ticket="item"
          :currency="currency" />

        <!-- Possible win and stake -->
        <vdog-active-ticket-summary
          class="summary"
          :isHistory="isHistory"
          :ticket="ticket"
          :currency="currency"/>
    </div>
  </div>
</template>

<script>
import VDogActiveTicketSummary from '@/components/grayhound/ticket/VDogActiveTicketSummary.vue'
import VDogActiveTicketSingleEvent from '@/components/grayhound/ticket/VDogActiveTicketSingleEvent.vue'
import ImageSVG from '@/components/common/ImageSVG.vue'
import TimeFormatter from '@/mixins/TimeFormatter'
import vuexStore from '../../../store/vuexStore'

import active from '../../../assets/audio/active_bet.mp3'

export default {
  mixins: [TimeFormatter],
  components: {
    'vdog-active-ticket-summary': VDogActiveTicketSummary,
    'vdog-active-ticket-single-event': VDogActiveTicketSingleEvent,
    'image-svg': ImageSVG
  },
  props: {
    ticket: {
      type: Object,
      required: true
    },
    currency: String,
    isActiveTicket: {
      type: Boolean,
      required: false,
      default: false
    },
    isHistory: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    onSelect: function () {
      this.$emit('onSelect')
    },
    getTicketId (ticket) {
      if (ticket.TicketList && ticket.TicketList.length > 0) {
        return ticket.TicketList[0].TicketID || ticket.TicketCheckID
      }
      return ''
    },
    getStatus: function (ticket) {
      let status = this.$t('vdog_active_ticket')
      if (!this.isActiveTicket) {
        if (ticket.Status === 1) {
          status = this.$t('vdog_winning')
        } else if (ticket.Status === 0) {
          status = this.$t('vdog_losing_ticket')
        }
      }
      return status
    },
    toggleTicketView (ticket) {
      if (this.hasAudioEnabled) {
        var audio = new Audio(active)
        audio.play()
      }
      ticket.isOpen = !ticket.isOpen
    }
  }
}
</script>
